<template>
  <van-nav-bar class="web-header base-header"
  >
    <template #title>
        <span style="color: #fff;">{{ safeTitle }}</span>
    </template>
    <template #left>
        <van-icon v-if="safeIsShowLeft" @click="onClickLeft" name="arrow-left" color="#fff" size="24" />
    </template>
    <template #right>
        <span style="color:#fff;" v-if="safeRight && !safeRightIcon" @click="onClickRight">{{ safeRight }}</span>
        <van-icon v-if="safeRightIcon" @click="onClickRight" :name="safeRightIcon" color="#fff" size="24" />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: "HeaderView",
  props:['title','leftclickName','right','rightclick','showleft','righticon'],
  computed:{
    safeRightIcon(){
        return this.righticon || null
    },
    safeIsShowLeft(){
        return this.showleft || true
    },
    safeRight(){
        return this.right || null
    },
    safeRightick(){
        return this.rightclick || null
    },
    safeTitle(){
        return this.title || ''
    },
    safeLeftLick(){
        return this.leftclickName || ''
    }
  },
  methods:{
    onClickLeft(){
        if(this.safeLeftLick.length > 0){
            this.$emit(this.safeLeftLick)
        } else {
            this.$router.back();
        }
    },
    onClickRight(){
        if(this.safeRightick){
            this.$emit(this.safeRightick)
        }
    }
  }
};
</script>
<style lang="scss">
.web-header{
    background-image: url('../../assets/img/header.svg') !important;
    background-repeat: no-repeat;
    background-size: 100% auto;
}
</style>
